import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dialog, DialogTitle, DialogContent, DialogActions, Select, MenuItem } from "@mui/material";
import Grid from "@mui/material/Grid2";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";
import { formatCurrency } from "../../utils/currency";

const INITIAL_FORM_STATE = {
  tipo_bien: "",
  tipo_inmueble: "",
  direccion: "",
  matricula_inmobiliaria: "",
  tipo_mueble: "",
  placa: "",
  marca: "",
  modelo: "",
  color: "",
  avaluo_catastral: "",
  avaluo_catastral_formatted: "",
  afectaciones: "",
};

const TIPOS_INMUEBLE = [
  { value: "CASA", label: "Casa" },
  { value: "APARTAMENTO", label: "Apartamento" },
  { value: "LOCAL", label: "Local" },
  { value: "OTRO", label: "Otro" },
];

// const TIPOS_MUEBLE = [
//   { value: "VEHICULO", label: "Vehículo" },
//   { value: "MOTOCICLETA", label: "Motocicleta" },
//   { value: "OTRO", label: "Otro" },
// ];

function NuevoBienForm({ open, onClose, onSubmit, procesoId }) {
  const [formData, setFormData] = useState(INITIAL_FORM_STATE);

  const handleTipoBienChange = (event) => {
    const tipoBien = event.target.value;
    setFormData({
      ...INITIAL_FORM_STATE,
      tipo_bien: tipoBien,
    });
  };

  const handleChange = (field) => (event) => {
    let value = event.target.value;
    if (field === "placa") {
      value = value.replace(/\s/g, "");
    }
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleMoneyChange = (field) => (event) => {
    const { formatted, value } = formatCurrency(event.target.value);
    setFormData((prev) => ({
      ...prev,
      [field]: value,
      [`${field}_formatted`]: formatted,
    }));
  };

  const handleSubmit = () => {
    if (!procesoId || !formData.tipo_bien) return;
    //Validaciones
    if (formData.avaluo_catastral.toString() === "") {
      alert("Debe ingresar un Avalúo.");
      return;
    }
    if (formData.tipo_bien === "INMUEBLE" && formData.tipo_inmueble === "") {
      alert("Debe seleccionar un Tipo de Inmueble.");
      return;
    }
    if (formData.tipo_bien === "MUEBLE" && formData.tipo_mueble === "") {
      alert("Debe seleccionar un Tipo de Mueble.");
      return;
    }
    const bienData = {
      //consecutivo: 1,
      proceso: procesoId,
      tipo_bien: formData.tipo_bien,
      avaluo_catastral: formData.avaluo_catastral.toString(),
      afectaciones: formData.afectaciones,
      ...(formData.tipo_bien === "INMUEBLE"
        ? {
            tipo_inmueble: formData.tipo_inmueble,
            direccion: formData.direccion,
            matricula_inmobiliaria: formData.matricula_inmobiliaria,
          }
        : {
            tipo_mueble: formData.tipo_mueble,
            placa: formData.placa,
            marca: formData.marca,
            modelo: formData.modelo,
            color: formData.color,
          }),
    };

    onSubmit(bienData);
    setFormData(INITIAL_FORM_STATE);
    onClose();
  };

  const handleClose = () => {
    setFormData(INITIAL_FORM_STATE);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <SuiTypography variant="h5">Nuevo Bien</SuiTypography>
      </DialogTitle>
      <DialogContent>
        <SuiBox py={1}>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}>
              <SuiBox mb={2}>
                <SuiTypography variant="h6" fontWeight="light">
                  Tipo Bien
                </SuiTypography>
                <Select value={formData.tipo_bien} onChange={handleTipoBienChange}>
                  <MenuItem value="">Seleccione un Tipo Bien</MenuItem>
                  <MenuItem value="INMUEBLE">Bien Inmueble</MenuItem>
                  <MenuItem value="MUEBLE">Bien Mueble</MenuItem>
                </Select>
              </SuiBox>
            </Grid>
            {formData.tipo_bien && (
              <Grid size={6}>
                <SuiBox mb={2}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Avalúo {formData.tipo_bien === "INMUEBLE" ? "Catastral" : ""}
                  </SuiTypography>
                  <SuiInput
                    value={formData.avaluo_catastral_formatted}
                    onChange={handleMoneyChange("avaluo_catastral")}
                  />
                </SuiBox>
              </Grid>
            )}
          </Grid>
          {formData.tipo_bien === "INMUEBLE" && (
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={4}>
                <SuiBox mb={2}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Tipo Inmueble
                  </SuiTypography>
                  <Select value={formData.tipo_inmueble} onChange={handleChange("tipo_inmueble")}>
                    <MenuItem value="">Seleccione un Tipo Inmueble</MenuItem>
                    {TIPOS_INMUEBLE.map((tipo) => (
                      <MenuItem key={tipo.value} value={tipo.value}>
                        {tipo.label}
                      </MenuItem>
                    ))}
                  </Select>
                </SuiBox>
              </Grid>
              <Grid size={4}>
                <SuiBox mb={2}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Dirección
                  </SuiTypography>
                  <SuiInput value={formData.direccion} onChange={handleChange("direccion")} />
                </SuiBox>
              </Grid>
              <Grid size={4}>
                <SuiBox mb={2}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Matrícula Inmobiliaria
                  </SuiTypography>
                  <SuiInput
                    value={formData.matricula_inmobiliaria}
                    onChange={handleChange("matricula_inmobiliaria")}
                  />
                </SuiBox>
              </Grid>
            </Grid>
          )}
          {formData.tipo_bien === "MUEBLE" ? (
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={6}>
                <SuiBox mb={2}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Tipo Mueble
                  </SuiTypography>
                  <SuiInput value={formData.tipo_mueble} onChange={handleChange("tipo_mueble")} />
                  {/* <Select value={formData.tipo_mueble} onChange={handleChange("tipo_mueble")}>
                    <MenuItem value="">Seleccione un Tipo Mueble</MenuItem>
                    {TIPOS_MUEBLE.map((tipo) => (
                      <MenuItem key={tipo.value} value={tipo.value}>
                        {tipo.label}
                      </MenuItem>
                    ))}
                  </Select> */}
                </SuiBox>
              </Grid>
              <Grid size={6}>
                <SuiBox mb={2}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Modelo
                  </SuiTypography>
                  <SuiInput value={formData.modelo} onChange={handleChange("modelo")} />
                </SuiBox>
              </Grid>
            </Grid>
          ) : null}
          {formData.tipo_bien === "MUEBLE" ? (
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={4}>
                <SuiBox mb={2}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Marca
                  </SuiTypography>
                  <SuiInput value={formData.marca} onChange={handleChange("marca")} />
                </SuiBox>
              </Grid>
              <Grid size={4}>
                <SuiBox mb={2}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Placa
                  </SuiTypography>
                  <SuiInput value={formData.placa} onChange={handleChange("placa")} />
                </SuiBox>
              </Grid>
              <Grid size={4}>
                <SuiBox mb={2}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Color
                  </SuiTypography>
                  <SuiInput value={formData.color} onChange={handleChange("color")} />
                </SuiBox>
              </Grid>
            </Grid>
          ) : null}
          {formData.tipo_bien && (
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={12}>
                <SuiBox mb={2}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Afectaciones
                  </SuiTypography>
                  <SuiInput
                    value={formData.afectaciones}
                    onChange={handleChange("afectaciones")}
                    multiline
                    rows={4}
                  />
                </SuiBox>
              </Grid>
            </Grid>
          )}
        </SuiBox>
      </DialogContent>
      <DialogActions>
        <SuiButton onClick={handleClose} buttonColor="light">
          Cancelar
        </SuiButton>
        <SuiButton onClick={handleSubmit} variant="gradient" buttonColor="dark">
          Agregar Bien
        </SuiButton>
      </DialogActions>
    </Dialog>
  );
}

NuevoBienForm.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  procesoId: PropTypes.number.isRequired,
};

export default NuevoBienForm;
